module.exports = __webpack_public_path__ + "img/amethyst.be5030ca.webp";